export default __webpack_public_path__ + "static/media/Manish_UI_UX(LEAD).c93baad0.jpg";